module.exports = __webpack_public_path__ + "img/Icon_Certificacion_Child_Count.7f81bd74.svg";